export default __webpack_public_path__ + "static/media/empty-state.3c5c37ad.svg";